export default __webpack_public_path__ + "static/media/Foto-15.bde34239.png";